import React from 'react';
import { Button } from 'reactstrap';

export const AudioMultipleDownload = ({
  handleMultiDownload,
  toggleMultiDownload,
  isMultiDownload,
  selectedRows
}) => {
  return (
    <>
      <label style={{ fontWeight: '400' }} className="form-control-label">
        <input
          onChange={handleMultiDownload}
          checked={isMultiDownload}
          type="checkbox"
        ></input>{' '}
        Download de Múltiplas Gravações
      </label>

      {isMultiDownload && selectedRows.length ? (
        <Button
          size="sm"
          color="primary"
          title="Realizar múltiplos download de chamadas"
          onClick={toggleMultiDownload}
          style={{ marginLeft: '.5rem' }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </Button>
      ) : null}
    </>
  );
};
